// extracted by mini-css-extract-plugin
module.exports = {"head-popup":"Popup_head-popup__gUSLv"};